import { render, staticRenderFns } from "./OnboardPricing.vue?vue&type=template&id=40c78484&scoped=true"
import script from "./OnboardPricing.vue?vue&type=script&lang=ts"
export * from "./OnboardPricing.vue?vue&type=script&lang=ts"
import style0 from "./OnboardPricing.vue?vue&type=style&index=0&id=40c78484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c78484",
  null
  
)

export default component.exports